import walletFinancialPositionsMessages from '../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../column';
import { LiquidityProduct } from '../liquidity-macro-category';

export const liquidityColumns: Column<LiquidityProduct>[] = [
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderContract,
    key: 'newContractCode',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderAccountBalance,
    key: 'accountBalance',
    type: 'amount',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderAccountBalanceDate,
    key: 'accountBalanceDate',
    type: 'date',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderCashBalance,
    key: 'cashBalance',
    type: 'amount',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderCashBalanceDate,
    key: 'cashBalanceDate',
    type: 'date',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderAvailableBalance,
    key: 'availableBalance',
    type: 'amount',
  },
  {
    headerLabel:
      walletFinancialPositionsMessages.tableHeaderAvailableBalanceDate,
    key: 'availableBalanceDate',
    type: 'date',
  },
];
